/**
 * Issue #73, shared copy for cart + checkout so users understand what’s included in estimates.
 * Totals always use {@link computeOrderTotals} from `./orderTotals`.
 */

export const PRE_CHECKOUT_ESTIMATE_FOOTNOTE =
  'Estimated total uses the same rules as checkout: 5% GST on your subtotal after promo, plus delivery when you choose delivery. Driver tips are optional and added at checkout.';

export const PRE_CHECKOUT_DELIVERY_VARIABLE_NOTE =
  'Delivery fee depends on your postal code and cart, it updates here and in checkout when your address is set.';
